var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lista-tavolo layout-panoramica-side-panel navy darken-2",
      class: { collapsed: _vm.collapsed },
    },
    [
      !_vm.collapsed
        ? _c("div", { staticClass: "lista-tavolo-content" }, [
            _c(
              "div",
              {
                staticClass: "titolo navy--text text--lighten-2 font-hemi-head",
              },
              [
                _c("span", [_vm._v("Partecipanti")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "lista-tavolo-actions" },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": "",
                          left: "",
                          "content-class": "section-options-menu-content",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2",
                                          attrs: {
                                            "x-small": "",
                                            rounded: "",
                                            depressed: "",
                                            title: "Opzioni lista",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("tune")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2026093415
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          {
                            staticClass: "section-options-menu navy darken-1",
                            attrs: { dense: "", dark: "" },
                          },
                          [
                            _c(
                              "v-subheader",
                              { staticClass: "section-options-menu-title" },
                              [_vm._v("\n              Mostra\n            ")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.displayOptions, function (option) {
                              return _c(
                                "v-list-item",
                                {
                                  key: option.key,
                                  attrs: { dense: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleDisplayOption(option.key)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          dense: "",
                                          "hide-details": "",
                                          readonly: "",
                                          "input-value":
                                            _vm.displayPrefs[option.key],
                                          color: "secondary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(option.label)),
                                      ]),
                                      _vm._v(" "),
                                      option.description
                                        ? _c(
                                            "v-list-item-subtitle",
                                            _vm._l(
                                              option.description,
                                              function (line) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: line,
                                                    staticClass: "d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(line) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": "",
                          left: "",
                          "content-class": "section-options-menu-content",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "section-title-action-btn lista-tavolo-sort-btn navy darken-3 navy--text text--lighten-3 px-2",
                                          attrs: {
                                            "x-small": "",
                                            rounded: "",
                                            depressed: "",
                                            title:
                                              "Ordina: " +
                                              _vm.currentSortOption.label,
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { "x-small": "" },
                                        },
                                        [_vm._v("fa-sort")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.currentSortOption.icon)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3130526492
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          {
                            staticClass: "section-options-menu navy darken-1",
                            attrs: { dense: "", dark: "" },
                          },
                          [
                            _c(
                              "v-subheader",
                              { staticClass: "section-options-menu-title" },
                              [
                                _vm._v(
                                  "\n              Ordina per\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.sortOptions, function (option) {
                              return _c(
                                "v-list-item",
                                {
                                  key: option.value,
                                  class: {
                                    "lista-tavolo-menu-item--selected":
                                      _vm.sortBy == option.value,
                                  },
                                  attrs: { dense: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.sortBy = option.value
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v(_vm._s(option.icon))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(option.label)),
                                  ]),
                                  _vm._v(" "),
                                  option.value == _vm.SORT_TAVOLO
                                    ? _c(
                                        "v-list-item-action",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                title: "Modifica ordine tavolo",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showAstaOrder.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("edit")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lista-tavolo-list nice-scroll" },
              _vm._l(_vm.sortedSquadre, function (squadraItem) {
                return _c("squadra-tavolo", {
                  key: squadraItem.id,
                  staticClass: "lista-tavolo-partecipante",
                  attrs: {
                    id: squadraItem.id,
                    variant: "line",
                    "menu-context":
                      _vm.Constants.SQUADRA_TAVOLO_MENU_CONTEXT.PANORAMICA,
                    "show-line-crediti": _vm.displayPrefs.crediti,
                    "show-line-max-offerta": _vm.displayPrefs.maxOfferta,
                    "show-line-max-offerta-bar": _vm.displayPrefs.maxOffertaBar,
                    "line-max-offerta-ratio": squadraItem.maxOffertaRatio,
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }